import * as React from 'react';
import { FileWithPath } from "@mantine/dropzone";
import { ActionIcon, createStyles } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

const useStyles = createStyles(() => {
    return {
        container: {
            position: 'relative',
            margin: '1rem 0'
        },
        image: {
            maxWidth: '100%'
        },
        remove: {
            position: 'absolute',
            top: 5,
            right: 5,
            zIndex: 1,
        }
    }
})

interface ImageRendererProps {
    src: string | FileWithPath;
    onRemove: () => void;
}

const ImageRenderer = ({
    src,
    onRemove
}: ImageRendererProps) => {

    const { classes } = useStyles();

    const imageSource = React.useMemo(() => {
        return typeof src === 'string' ? src : URL.createObjectURL(src);
    }, [src]);

    return (
        <div className={classes.container}>
            <img
                className={classes.image}
                src={imageSource}
                onLoad={() => URL.revokeObjectURL(imageSource)}
                alt=''
            />
            <div className={classes.remove}>
                <ActionIcon color='red' style={{ background: '#e7e7e7' }} onClick={onRemove}>
                    <IconTrash/>
                </ActionIcon>
            </div>
        </div>
    )
};

export default ImageRenderer;